export default __webpack_public_path__ + "static/media/Mask Group 1.f9bf62b3.png";